import React, {
  ChangeEvent,
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  ListItemText,
  ListItem,
  FormControlLabel,
  Checkbox,
  Grid,
  Button,
  Select,
  Typography,
} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import { strings } from "./strings";
import { Log } from "./save";
import * as cms from "./ro_all_cms";

import { AuthContext, CurrentFormContext } from "../contexts";

import { useLocation, useHistory } from "react-router-dom";
import { Agency } from "../contexts/AuthContext";

const agentApp = {
  saved: false,
};
window.onbeforeunload = (e: any) => {
  if (window.location.pathname === "/mark" && agentApp.saved === false)
    return false;
};

interface SelectorProps {
  data: { label: string; value: string }[];
  name: string;
  defaultValue?: string;
  prompt?: string;
  session?: boolean;
  style?: object;
  combinedLabel?: boolean;
  onChange: (value: string) => void;
  value: string;
}

const Selector: FunctionComponent<SelectorProps> = ({
  data,
  prompt,
  style,
  combinedLabel,
  onChange,
  value,
}) => {
  const [, setselected] = useState<string | undefined>(undefined);

  const handleChange = (
    event: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const newValue: string = event.target.value as string;
    setselected(newValue);

    onChange(newValue);
  };

  return (
    <Select
      native
      style={style}
      name="agent-code-select"
      onChange={handleChange}
      value={value || "DEFAULT"}
    >
      <option value="DEFAULT" disabled>
        {prompt || "please select"}
      </option>
      {data.map((code, i) => {
        if (!combinedLabel || code.label === "EXIT") {
          return (
            <option key={i} value={code.value}>
              {code.label}
            </option>
          );
        } else {
          return (
            <option key={i} value={code.value}>
              {code.value}-{code.label}
            </option>
          );
        }
      })}
    </Select>
  );
};

const SecondaryCodeSelector: FunctionComponent<
  { value: string; selectedValues: string[] } & OnChange<string[]>
> = ({ value, onChange, selectedValues }) => {
  const [codes, setCodes] = useState<any>(undefined);
  useEffect(() => {
    cms.getCodes().then(setCodes);
  }, [value]);

  let result = null;

  if (value === "S" && codes) {
    const list = codes.data.listSecondarys.items.map(
      (item: { number: number; text: string }) => {
        return { value: item.number, label: item.text };
      }
    );
    result = (
      <AccordionSelect
        codes={list}
        prompt="Secondary"
        onChange={onChange}
        selectedValues={selectedValues}
      />
    );
  }
  return result;
};

class AgentCodeSelector extends React.Component<
  OnChange<string>,
  {
    selectedItem: string;
    currentValue: string;
    accordionOpen: boolean;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentValue: "",
      accordionOpen: false,
      selectedItem: "",
    };
  }

  // componentDidMount() {
  //   this.setState({ ...this.state });
  // }
  render() {
    const { selectedItem } = this.state;
    return (
      <div style={{ fontSize: ".01em" }}>
        <Accordion
          style={{
            bottom: "1px",
            position: "absolute",
          }}
          id="acode-select-accordion"
        >
          <AccordionSummary
            expandIcon={<ExpandLessIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            // style={{border: '1px solid blue'}}
          >
            <Typography id="codeTitle">Code</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div key={"_children"}>
              {strings.agentCodes.map((x) => {
                return (
                  <ListItem
                    button
                    selected={selectedItem === x.value}
                    key={x.value}
                    onClick={() => {
                      const newValue = `${x.label}`;
                      this.setState({ selectedItem: newValue });

                      this.props.onChange(newValue);
                      document.getElementById("panel1a-header")!.click();
                      document.getElementById("codeTitle")!.innerHTML =
                        newValue;
                    }}
                  >
                    <ListItemText primary={x.label} />
                  </ListItem>
                );
              })}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
}

interface AccordionSelectProps extends OnChange<string[]> {
  codes: [{ value: string; label: string }];
  prompt: string;
  selectedValues: string[];
}
interface AccordionSelectState {
  visible: "none" | "default";
  codes: [{ value: string; label: string }];
  prompt: string;
  selected: { [prop: string]: boolean }[];
}

class AccordionSelect extends React.Component<
  AccordionSelectProps,
  AccordionSelectState
> {
  constructor(props: AccordionSelectProps) {
    super(props);
    this.state = {
      visible: "default",
      codes: props.codes,
      prompt: props.prompt,

      selected: props.codes.map((code) => ({
        [code.value]: false,
      })),
    };
  }
  render() {
    const { codes, prompt } = this.state;
    const { onChange, selectedValues } = this.props;
    return (
      <div>
        <input type="hidden" id="secondary-select" value={selectedValues} />
        <Accordion
          style={{
            width: "500px",
            display: this.state.visible,
            bottom: "1px",
            position: "absolute",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandLessIcon />}
            aria-controls="panel1a-content-secondary"
            id="panel1a-header-secondary"
            // style={{border: '1px solid green'}}
          >
            <Typography>{prompt}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              {codes.map((x) => {
                return (
                  <Grid lg={5} item key={x.label + "_grid"}>
                    <div
                      style={{ display: "flex", flexWrap: "wrap" }}
                      key={x.label}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            key={x.label + "_check"}
                            onChange={(event) => {
                              if (event.target.checked) {
                                if (selectedValues.length === 0) {
                                  onChange([event.target.id]);
                                } else {
                                  onChange([
                                    event.target.id,
                                    ...selectedValues,
                                  ]);
                                }
                              } else {
                                onChange(
                                  selectedValues.filter(
                                    (x) => x !== event.target.id
                                  )
                                );
                              }
                            }}
                            checked={selectedValues.indexOf(x.value) !== -1}
                            name={x.value}
                            id={x.value}
                            color="primary"
                          />
                        }
                        label={x.value + "-" + x.label}
                      />
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
}

interface HomeButtonProps {
  onClick: () => void;
}

const HomeButton: FunctionComponent<HomeButtonProps> = ({ onClick }) => {
  const { setForm } = useContext(CurrentFormContext);
  const history = useHistory();
  const handleClick = () => {
    setForm(undefined);
    history.push("/");
    onClick();
  };
  return (
    <Button onClick={handleClick} name="home" id="home" value="Restart">
      Restart
    </Button>
  );
};

interface SaveButtonProps {
  failure: (message: string) => void;
  secondaryCodes: string[];
  code: string;
  location: string;
  onSave: (input: LogSave) => Promise<void>;
  agency: Agency;
}

interface LogSave {
  QRCodeBase: string;
  location: string;
  action: string;
  agent: string;
  userId: string;
  secondary: string;
}

const SaveButton: FunctionComponent<SaveButtonProps> = ({
  failure,
  code,
  secondaryCodes,
  location,
  onSave,
  agency,
}) => {
  const auth = useContext(AuthContext);
  const { form } = useContext(CurrentFormContext);
  const QRCodeBase = form ? form.QRCodeBase : "";

  const isActive = () => {
    return (
      location &&
      code &&
      auth &&
      QRCodeBase &&
      ((code === "S" &&
        ((secondaryCodes && secondaryCodes.length > 0) || agency !== "CQA")) ||
        code === "F")
    );
  };
  const clickHandler = async () => {
    let hasFailed = false;
    const fail = (message: string) => {
      hasFailed = true;
      failure(message);
    };
    if (location && code && auth) {
      let logValues: LogSave = {
        location,
        action: code,
        agent: auth.username,
        userId: auth.id,
        QRCodeBase,
        secondary: "",
      };
      if (code === "S") {
        if ((secondaryCodes && secondaryCodes.length) || agency !== "CQA") {
          logValues.secondary = secondaryCodes.join(",");
        } else {
          fail("Please enter a secondary code");
        }
      } else if (code === "F") {
        if (location === "Exit") {
          logValues.secondary = "EXIT";
        }
      } else {
        fail("Please enter a primary code");
      }

      if (!hasFailed) {
        try {
          await onSave(logValues);
          agentApp.saved = true;
        } catch (e) {
          console.log("error: %o", e);
        }
      }
      if (document.getElementById("panel1a-header-secondary")) {
        document.getElementById("panel1a-header-secondary")!.click();
      }
    } else if (!location) {
      fail("No location chosen");
    } else if (!code) {
      fail("Please enter a primary code");
    } else if (!auth) {
      fail("Please log in again");
    }
  };
  return (
    <Button
      onClick={clickHandler}
      name="save"
      id="save"
      value="Save"
      disabled={!isActive()}
    >
      Save
    </Button>
  );
};

interface OnChange<T> {
  onChange: (value: T) => void;
}

const LocationSelect: FunctionComponent<
  { value: string; agency: Agency } & OnChange<string>
> = ({ onChange, value, agency }) => {
  useEffect(() => {
    if (agency === "Health") {
      onChange("Health");
    } else if (value === "Health") {
      onChange("");
    }
  }, [agency, value, onChange]);

  // if health, set and don't show.
  if (agency === "Health") {
    return null;
  } else {
    // otherwise show
    return (
      <Selector
        data={strings.agentLocations}
        prompt="Location"
        name="location-select"
        onChange={onChange}
        value={value}
      />
    );
  }
};

interface ButtonsProps {
  fail: (msg: string) => void;
}

const Buttons: FunctionComponent<ButtonsProps> = (props) => {
  const [location, setLocation] = useState<string>(
    localStorage.getItem("location-select") || ""
  );
  const [code, setCode] = useState<string>("");
  const [secondaryCodes, setSecondaryCodes] = useState<string[]>([]);
  const [path, setPath] = useState<string>("");
  const windowLocation = useLocation();
  const { agency } = useContext(AuthContext);
  useEffect(() => {
    setPath(windowLocation.pathname);
  }, [windowLocation]);

  useEffect(() => {
    localStorage.setItem("location-select", location);
  }, [location]);

  const resetCodes = () => {
    setCode("");
    setSecondaryCodes([]);
  };

  const onLogSave = async (input: LogSave) => {
    resetCodes();
    await Log(input);
  };

  return (
    <div id="buttonHolder" className="buttons">
      <Grid container>
        {path === "/" || path === "/search" ? (
          <Grid item>
            <LocationSelect
              agency={agency}
              onChange={(val) => {
                setLocation(val);
              }}
              value={location}
            />
          </Grid>
        ) : null}
        {path === "/mark" ? (
          <Grid item>
            <AgentCodeSelector onChange={setCode} />
          </Grid>
        ) : null}
        {path === "/mark" && code === "S" && agency === "CQA" ? (
          <Grid item id="second" style={{ marginLeft: "100px" }}>
            <SecondaryCodeSelector
              value={code}
              selectedValues={secondaryCodes}
              onChange={setSecondaryCodes}
            />
          </Grid>
        ) : null}
        {path === "/mark" ? (
          <Grid style={{ marginLeft: "auto" }} item>
            <SaveButton
              failure={props.fail}
              agency={agency}
              code={code}
              secondaryCodes={secondaryCodes}
              location={location}
              onSave={onLogSave}
            />
          </Grid>
        ) : null}
        {path === "/mark" ? (
          <Grid style={{ marginLeft: "20px" }} item>
            <HomeButton onClick={resetCodes} />
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

export default Buttons;
